<div *ngIf="isLoading.invoice" class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
  <div class="m-loader m-loader--brand"></div>
</div>
<ng-container *ngIf="!isLoading.invoice">
  <div class="m-subheader" style="position: relative;">
    <div class="d-flex align-items-center" style="flex-wrap: wrap;">
      <div class="mr-auto">
        <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
          <li class="m-nav__item m-nav__item--home">
            <a routerLink="/" class="m-nav__link m-nav__link--icon">
              <i class="m-nav__link-icon la la-home"></i>
            </a>
          </li>
          <li class="m-nav__separator">
            -
          </li>
          <li class="m-nav__item">
            <a (click)="goBack()" class="m-nav__link">
            <span class="m-nav__link-text">
              {{ 'storage-invoice-view.allInvoice' | transloco }}
            </span>
            </a>
          </li>
          <li class="m-nav__separator">
            -
          </li>
          <li class="m-nav__item">
            <span class="m-nav__link-text">№{{ invoice?.number }}</span>
          </li>
        </ul>
      </div>

      <div>
        <div *ngIf="!invoice?.paymentDate && invoice?.status !== 'REJECTED'">
          <button (click)="paidConfirm()"
                  [disabled]="isLoading.paid"
                  [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.paid}"
                  type="button"
                  class="btn btn-outline-warning m-btn m-btn--icon m--margin-right-10"
                  [title]="'storage-invoice-view.paid' | transloco">
            <span>
              <i class="la la-money-bill"></i>
              <span>{{ 'storage-invoice-view.paid' | transloco }}</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="m-content">
    <!--Begin::Main Portlet-->
    <div class="row">
      <div class="col-sm-12">
        <div class="m-portlet m-portlet--{{ statusList[invoice?.status]?.badge }} m-portlet--head-solid-bg">
          <div class="m-portlet__head" style="position: relative;">
            <div [ngClass]="{'invisible': (invoice | json) === '{}'  && isLoading.invoice }"
                 class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  {{ 'storage-invoice-view.invoice' | transloco }}{{ invoice?.number }} {{ 'storage-invoice-view.from' | transloco }} {{ invoice?.createDate | date: 'dd.MM.yyyy HH:mm' }}
                </h3>
              </div>
            </div>

            <div class="m-portlet__head-tools">
              <ul class="m-portlet__nav">
                <li class="m-portlet__nav-item">
                    <span
                      class="m-badge  m-badge--{{ statusList[invoice?.status]?.badge }} m-badge--wide m-badge--rounded">
                      {{ 'action.' + invoice?.status | transloco }}
                    </span>
                </li>
              </ul>
            </div>

            <div *ngIf="!invoice && isLoading.invoice"
                 class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
              <div class="m-loader m-loader--brand"></div>
            </div>
          </div>

          <div class="m-portlet__body">
            <div *ngIf="(invoice | json) !== '{}'  && !isLoading.invoice" class="row">
              <div class="col-md-12">

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'storage-invoice-view.number' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      №{{ invoice?.incomingInvoiceNumber }}
                    </div>
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'storage-invoice-view.data' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      {{ invoice?.incomingInvoiceDate | date: 'dd.MM.yyyy' }}
                    </div>
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'storage-invoice-view.supplier' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    {{ invoice?.supplier?.name }} ({{ invoice?.supplier?.uin }})
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'storage-invoice-view.sum' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                  <span class="h5 m--font-success">
                    {{ invoice?.totalPrice | uiCurrency:invoice?.currency}}
                  </span>
                    <span *ngIf="invoice?.paymentType">
                    ({{ 'paymentType.' + invoice?.paymentType | transloco }})
                  </span>
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'storage-invoice-view.spendType' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    {{ invoice?.spendCategory?.title | uiLabel }}
                  </div>
                </div>

                <div class="form-group m-form__group row" *ngIf="invoice?.contract">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'storage-invoice-view.treaty' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <a [routerLink]="'/storage/contracts/' + invoice?.contract?.id">
                      {{ invoice?.contract?.title }} №{{ invoice?.contract?.number }}
                      {{ 'storage-invoice-view.from' | transloco }} {{ invoice?.contract?.date | date:'dd.MM.yyyy' }}
                    </a>
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'storage-invoice-view.shop' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      {{ invoice?.store?.title | uiLabel }}
                    </div>
                    <small>
                      {{ invoice?.store?.address }}
                    </small>
                  </div>
                </div>

                <div class="form-group m-form__group row" *ngIf="invoice?.dueDate">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'storage-invoice-view.term' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      {{ invoice?.dueDate | date:'dd.MM.yyyy' }}
                    </div>
                  </div>
                </div>

                <div class="form-group m-form__group row" *ngIf="invoice?.paymentDate">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'storage-invoice-view.dataPaid' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      {{ invoice?.paymentDate | date:'dd.MM.yyyy HH:mm' }}
                    </div>
                  </div>
                </div>

                <table class="table m--margin-bottom-0" *ngIf="invoice?.files && invoice?.files.length > 0">
                  <thead class="thead-default">
                  <tr>
                    <th>{{ 'storage-invoice-view.table.head.file' | transloco }}</th>
                  </tr>
                  </thead>
                </table>
                <div class="is--responsive-table">
                  <div class="m-widget4 m-widget4--padding" *ngIf="invoice?.files.length > 0">
                    <div class="m-widget4__item" *ngFor="let file of invoice?.files">
                      <a *ngIf="file.mimeType !== 'application/pdf'" class="m-widget4__img m-widget4__img--icon"
                         (click)="showImage(file)">
                        <img [src]="baseLink + file.guid" [alt]="file.fileName">
                      </a>
                      <a *ngIf="file.mimeType === 'application/pdf'" class="m-widget4__img m-widget4__img--icon"
                         (click)="showImage(file)">
                        <i class="la la-file-pdf-o la-2x"></i>
                      </a>
                      <div class="m-widget4__info" [title]="file.fileName">
                          <span class="m-widget4__text">
                            {{ file.fileName }}
                          </span>
                      </div>
                    </div>
                  </div>

                </div>

                <table class="table m--margin-bottom-0">
                  <thead class="thead-default">
                  <tr>
                    <th>{{ 'storage-invoice-view.table.head.products' | transloco }}</th>
                  </tr>
                  </thead>
                </table>
                <div class="is--responsive-table">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>{{ 'storage-invoice-view.table.head.name' | transloco }}</th>
                      <th>{{ 'storage-invoice-view.table.head.shelf' | transloco }}</th>
                      <th class="text-right">{{ 'storage-invoice-view.table.head.products' | transloco }}</th>
                      <th class="text-right">{{ 'storage-invoice-view.table.head.num' | transloco }}</th>
                      <th class="text-right">{{ 'storage-invoice-view.table.head.quantity' | transloco }}</th>
                      <th class="text-right">{{ 'storage-invoice-view.table.head.price' | transloco }}</th>
                      <th class="text-right">{{ 'storage-invoice-view.table.head.sum' | transloco }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let product of invoice?.products">
                      <td>
                        {{ product.title | uiLabel }}
                      </td>
                      <td>
                        <span *ngIf="product.issueDate">{{ 'storage-invoice-view.with' | transloco }} {{ product.issueDate | date: 'dd.MM.yyyy' }}</span>
                        <span *ngIf="product.expiryDate"> {{ 'storage-invoice-view.on' | transloco }} {{ product.expiryDate | date: 'dd.MM.yyyy' }}</span>
                      </td>
                      <td class="text-right">
                        {{ product.spendType?.title | uiLabel }}
                      </td>
                      <td class="text-right">
                        {{ product.unitOfMeasureTitle | uiLabel }}
                      </td>
                      <td class="text-right text-nowrap">
                        {{ product.amount }}
                      </td>
                      <td class="text-right text-nowrap">
                        {{ product.pricePerUnit }}
                      </td>
                      <td class="text-right text-nowrap">
                        {{ product.totalValue | uiCurrency:invoice?.currency}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h5>{{ 'storage-invoice-view.total' | transloco }}</h5>
                      </td>
                      <td colspan="5"></td>
                      <td class="text-right text-nowrap">
                        <h5 class="m--font-success">
                          {{ invoice?.totalPrice | uiCurrency:invoice?.currency }}
                        </h5>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <table class="table m--margin-bottom-0" *ngIf="events && events.length > 0">
                    <thead class="thead-default">
                    <tr>
                      <th>{{ 'storage-invoice-view.table.head.info' | transloco }}</th>
                    </tr>
                    </thead>
                  </table>

                  <div class="is--responsive-table" *ngIf="events && events.length > 0">
                    <table class="hc-table">
                      <thead class="hc-table__head">
                      <tr class="hc-table__row hc-table__row--head">
                        <td class="hc-table__cell">{{ 'storage-invoice-view.date' | transloco }}</td>
                        <td class="hc-table__cell">{{ 'storage-invoice-view.author' | transloco }}</td>
                        <td class="hc-table__cell">{{ 'storage-invoice-view.note' | transloco }}</td>
                        <td class="hc-table__cell">{{ 'storage-invoice-view.status' | transloco }}</td>
                      </tr>
                      </thead>

                      <tbody class="hc-table__body" *ngFor="let event of events">
                      <tr class="hc-table__tow">
                        <td class="hc-table__cell">
                          <span>{{event.date | date: 'dd.MM HH:mm' }}</span>
                        </td>
                        <td class="hc-table__cell">
                          <span [title]="event.actorFullName + ' - ' + event.actor">{{ event.actorFullName | fio }}</span>
                        </td>
                        <td class="hc-table__cell">
                          {{ event.info }}
                        </td>
                        <td class="hc-table__cell">
                          <span class="m-badge m-badge--{{eventList[event.type]?.badge }} m-badge--wide m-badge--rounded">
                            {{ 'invoice.type.' + event.type | transloco }}
                          </span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="m-form__actions m-form__actions--paddingless-sides">
                    <div class="row">
                      <div class="col-12 text-right">
                        <button *ngIf="hasPermissionReject(invoice?.status, invoice?.sendDate, invoice?.receiveDate)"
                                [disabled]="isLoading?.submit" type="submit" (click)="showModal(invoice?.id, 'reject')"
                                class="btn btn-danger">
                          {{ 'btn.reject' | transloco }}
                        </button>
                        <button *ngIf="hasPermissionCancel(invoice?.status, invoice?.sendDate, invoice?.receiveDate)"
                                [disabled]="isLoading?.submit" type="submit" (click)="showModal(invoice?.id, 'cancel')"
                                class="btn btn-danger">
                          {{ 'btn.cancel' | transloco }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="(invoice | json) === '{}' && isLoading.invoice"
                 class="m-page-loader m-page-loader--non-block m-page-loader--relative">
              <div class="m-loader m-loader--brand"></div>
            </div>
          </div>
        </div>

        <a routerLink="../" class="is--cursor-pointer">
          {{ 'storage-invoice-view.back' | transloco }}
        </a>
      </div>
    </div>
    <!--End::Main Portlet-->
  </div>
</ng-container>
<ng-template #templateRef let-modal>
  <div class="modal-header">
    <h3 class="modal-title">{{ image?.name }}</h3>
    <button class="close" type="button" (click)="closeModal(modal)"></button>
  </div>

  <div class="modal-body text-center">
    <iframe *ngIf="image.mimeType === 'application/pdf'" class="iframe" width="100%" height="100%" [src]="image.path"
            frameborder="0"></iframe>
    <img *ngIf="image.mimeType !== 'application/pdf'" [src]="image.path" [alt]="image?.name"
         style="max-width: 100%;">
  </div>
</ng-template>
